<template>
  <div>
    <div
      v-if="sort && !somatory"
      :style="
        `display: flex; gap: 0.5rem; ${
          columnType
            ? 'text-align: end; flex-direction: column;'
            : 'flex-direction: row;'
        }`
      "
    >
      <span> {{ columnName }} </span>
      <div style="display: flex; justify-content: end;">
        <span>{{ columnType || '' }}</span>
        <RenderSortColumn
          :columnName="columnName"
          :columnKey="columnKey"
          :currentColumnFiltered="currentColumnFiltered"
          :sortDirection="sortDirection"
          v-on:sortListByKey="sortListByKey(columnKey)"
        />
      </div>
    </div>

    <div
      v-if="!sort && somatory"
      style="display: flex; flex-direction: column;"
    >
      <span>
        {{ columnName }} {{ columnType === '(QTY)' ? '' : columnType }}
      </span>
      <span v-if="columnType === '(QTY)'"> {{ dataList.length }} </span>
      <RenderSomatoryColumnValue
        v-else
        :data-list="dataList"
        :property="columnName"
      />
    </div>

    <div
      v-if="sort && somatory"
      style="display: flex; flex-direction: column; text-align: end;"
    >
      <span>{{ columnName }}</span>
      <div style="display: flex; justify-content: end;">
        <span>{{ columnType }}</span>
        <RenderSortColumn
          :columnName="columnName"
          :columnKey="columnKey"
          :currentColumnFiltered="currentColumnFiltered"
          :sortDirection="sortDirection"
          v-on:sortListByKey="sortListByKey(columnKey)"
        />
      </div>
      <RenderSomatoryColumnValue :data-list="dataList" :property="columnKey" />
    </div>

    <span v-if="!sort && !somatory">{{ columnName }}</span>
  </div>
</template>

<script>
import { RenderSomatoryColumnValue, RenderSortColumn } from '../render';

export default {
  components: {
    RenderSortColumn,
    RenderSomatoryColumnValue,
  },
  props: {
    sort: {
      type: Boolean,
      default: false,
      required: true,
    },
    somatory: {
      type: Boolean,
      default: false,
      required: true,
    },
    columnKey: {
      type: String,
      default: '',
      required: true,
    },
    columnName: {
      type: String,
      default: '',
      required: true,
    },
    currentColumnFiltered: {
      type: String,
      default: '',
      required: false,
    },
    sortDirection: {
      type: String,
      default: 'ASC',
      required: false,
    },
    dataList: {
      type: Array,
      default: [],
      required: false,
    },
    columnType: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    sortListByKey() {
      this.$emit('sortListByKey');
    },
  },
};
</script>
